import { Component, ViewEncapsulation } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

export interface SelectComponentOption {
  id: any;
  label: string;
}

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class SelectComponent extends FieldType {}
